export const priceMapping = {
  price1m: '1 Month',
  price12m: '12 Month',
  price24m: '24 Month',
  price36m: '36 Month',
}

export const priceMappingWithAll = {
  price1m: '1 Month',
  price12m: '12 Months',
  price24m: '24 Months',
  price36m: '36 Months',
  subscriptionPrice: 'Price',
}
